export const padNumber = (number) => (Number(number) < 10 ? `0${number}` : `${number}`);

export const scrollToElement = (selector) => {
	const element = document.querySelector(selector);
	element.scrollIntoView({
		behavior: 'smooth'
	});
};

export const scrollToNode = (node) => {
	node.scrollIntoView({
		behavior: 'smooth'
	});
};

export const scrollToTop = () => {
	document.documentElement.scrollTop = document.body.scrollTop = 0;
	document.documentElement.scrollLeft = document.body.scrollLeft = 0;
};

export const getDataFromForm = (form) => {
	const formData = new FormData(form);
	const dataObject = {};
	for (const [key, value] of formData.entries()) {
		dataObject[key] = value;
	}
	return dataObject;
};
